module.exports = __webpack_public_path__ + "assets/plus-minus-box.9d5a380a.svg";